module.exports = __webpack_public_path__ + "1-35.png?73d61c0dd94cbbc39c6fd660c7582dfd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1-35.png
// module id = 112
// module chunks = 0